import React from 'react';
import { useTranslation } from 'react-i18next';
const OutOfStockBlock = (props) => {
    const { t } = useTranslation();
    const { isComingSoon, showSimilarProductsOOS } = props;
    const label = isComingSoon ? t('label.comingsoonlong') : t('label.outofstock');
    return (React.createElement("div", { className: "size-selection-button blocked" },
        React.createElement("div", null,
            React.createElement("i", { className: "alert icon--alert" }),
            React.createElement("span", null, label)),
        showSimilarProductsOOS && (React.createElement("button", { type: "button", className: "button button--link-button", onClick: () => props.openSimilarModal() }, t('similarproduct.title')))));
};
export default OutOfStockBlock;
